(() => {
  const root = document.querySelector('[data-size-guide]');
  if (!root) return;
  const convert = value => value.replace(/\d+(?:\.\d+)?/g, number => (Number(number) / 2.54).toFixed(1));
  const region = root.querySelector('[data-region]');
  const status = root.querySelector('[data-region-status]');
  const updateChart = () => {
    const referenceRegion = region.value === 'us-uk-eu';
    const gender = root.querySelector('[data-gender][aria-pressed="true"]').dataset.gender;
    root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = !referenceRegion || panel.dataset.panel !== gender; });
    status.hidden = referenceRegion;
    status.textContent = referenceRegion ? '' : 'This region needs product-specific size confirmation. Send us your measurements and product link; the US / UK / EU example chart is hidden to avoid suggesting a false conversion.';
  };
  root.querySelectorAll('[data-gender]').forEach(button => button.addEventListener('click', () => {
    root.querySelectorAll('[data-gender]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    updateChart();
  }));
  root.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
    const inches = button.dataset.unit === 'in';
    root.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelectorAll('[data-cm]').forEach(cell => { cell.textContent = inches ? convert(cell.dataset.cm) : cell.dataset.cm; });
    root.querySelectorAll('[data-unit-label]').forEach(label => { label.textContent = inches ? '(in)' : '(cm)'; });
  }));
  region.addEventListener('change', updateChart);
  root.querySelectorAll('[data-pick-region]').forEach(button => button.addEventListener('click', () => {
    region.value = button.dataset.pickRegion;
    region.dispatchEvent(new Event('change'));
    region.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));
})();
